/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
    // Add custom code below this line
    
    /*
    // Home page uniform grid for multicolumns
    function uniform_grid() {
      
      //Things
      const columnsWithImagesContainers = document.querySelectorAll('[data-section-type=columns-with-image]');
      
      console.log(columnsWithImagesContainers);
      
      //Functions
      function manageColumnHeight(container){
        const columns = container.querySelectorAll(container);
        let highest = 0;
        columns.forEach(column => {
          if (column.clientHeight > highestBox) {
            highest = column.clientHeight;
          }
        });
        columns.forEach(column => {
          column.setAttribute("style", "height:" + highest + "px; display:flex; flex-direction:column; justify-content:space-around;");
        })
      }
      
      //actions
      columnsWithImagesContainers.forEach(container =>{
        manageColumnHeight(container);
      });
      
    }
  
    uniform_grid();
    
    window.addEventListener("resize", function() {
      uniform_grid();
    });
    */
    
    // PDP variant inventory check
    function getParameterByName(name, url = window.location.href) {
      name = name.replace(/[\[\]]/g, '\\$&');
      var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
          results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }
  
    if(document.querySelector('[data-product-remaining-json]')){
      const variantData = document.querySelector('[data-product-remaining-json]').innerHTML;

      if(variantData) {
        window.addEventListener("theme:variant:change", function() {
          var productPriceTag = document.querySelector('[data-product-price]');
          var productPriceButtonTag = document.querySelector('[data-product-button-price]');
          var productPriceVal = productPriceTag.innerHTML.replace(/\.00$/,'');

          productPriceTag.style.opacity = "0";

          setTimeout(function(){
            productPriceTag.innerHTML = productPriceVal;
            productPriceButtonTag.innerHTML = productPriceVal;

            let currentVariant = getParameterByName('variant');
            let variantArray = JSON.parse(variantData, function (key, value) {
              if (key == currentVariant) {
                document.querySelector('[data-remaining-count]').innerHTML = value;
                if(value > 0 && value < 11) {
                  document.querySelector('[data-remaining-wrapper]').style.display = "block";
                } else {
                  document.querySelector('[data-remaining-wrapper]').style.display = "none";
                }
              }
            });

            productPriceTag.style.opacity = "1";
          }, 100);
        }, false);
      } 
    }
    
    // MEMBERSHIP SIGNUP SECTION
    
    function membershipSection() {
      
      const sections = document.querySelectorAll('.membership__form');
      if (!sections) return;
      
      sections.forEach(section => {
        
        const buttons = section.querySelectorAll('.membership__btn');
        const select = section.querySelector('.membership__select');
        const submit = section.querySelector('.membership__submit-btn');
        const variant_input = section.querySelector('input[name="id"]');
        const selling_plan_input = section.querySelector('input[name="selling_plan"]');
        
        function updateMembershipItem(el) {
          
          if (el) {
            section.dataset.productid = el.dataset.product_id;
            variant_input.dataset.product_id = el.dataset.product_id;
            variant_input.value = el.dataset.variant_id;
            selling_plan_input.value = el.dataset.selling_plan_id;
          }
          else {
            section.dataset.productid = '';
            variant_input.dataset.product_id = '';
            variant_input.value = '';
            selling_plan_input.value = '';
          }
        }
        
        // handle buttons
        if (buttons) {
          buttons.forEach(button => {
            button.addEventListener("click", (e) => {
              e.preventDefault();
              const button = e.target;
              
              // un-highlight other inputs
              buttons.forEach(button => { button.classList.remove('is-selected') });
              if (select) {
                select.selectedIndex = 0;
                select.classList.remove('is-selected');
              }
              
              // highlight this input
              button.classList.add('is-selected');
              
              // update selected membership level
              updateMembershipItem(button);
            });
          });
        }
        
        // handle select
        if (select) {
          select.addEventListener("change", (e) => {
            
            if (select.value != '') {
              
              // un-highlight other inputs
              if (buttons) {
                buttons.forEach(button => { button.classList.remove('is-selected') });
              }
              
              // highlight this input
              select.classList.add('is-selected');
              
              // update selected membership level
              updateMembershipItem(select.selectedOptions[0]);
            }
            else {
              
              // un-highlight this
              select.classList.remove('is-selected');
              select.blur();
              
              // update selected membership level
              updateMembershipItem(null);
            }
          });
        }
        
      });
    }
    membershipSection();
    
    
    // MEMBERSHIP GATEWAY
    
    function membershipGateway() {
      
      const gateway = document.getElementById('cm-gateway-message');
      if (!gateway) return;
      
      const uri = '/' + location.pathname.substr(1);
      sessionStorage.setItem("return_uri", uri);
    }
    membershipGateway();
    
    
    // MEMBERSHIP LOGIN SECTION
    
    function membershipLogin() {
      
      const return_to_input = document.getElementById('return_to_input');
      if (!return_to_input) return;
      
      const return_uri = sessionStorage.getItem("return_uri");
      
      if (return_uri && return_uri.length > 1) {
        return_to_input.value = return_uri;
      }
    }
    membershipLogin();
  
    // ^^ Keep your scripts inside this IIFE function call to 
    // avoid leaking your variables into the global scope.
  
  })();
  